export class NewPayouts{
    constructor(
        public isPayoutYN: string = "",
        public limit: any = null,
    ){}
}